import { type AiBuilderActiveOperation } from '../stores/aiBuilderSessionStore';

/**
 * 지금 생성기를 실행할 수 있는가 — 우선순위: 게스트 > AI 채팅 응답 중 > 무료 소진.
 * 실행 버튼을 막는 이유와 입력창 위 상시 배너가 모두 이 결과 하나에서 나온다.
 */
export type AiGenerateDockGate =
  | { kind: 'open' }
  | { kind: 'guest' }
  | { kind: 'chatBusy' }
  | { kind: 'quotaExhausted' };

export type AiGenerateDockGateKind = AiGenerateDockGate['kind'];

export const resolveAiGenerateDockGate = ({
  isGuest,
  activeOperation,
  quotaExhausted,
}: {
  isGuest: boolean;
  activeOperation: AiBuilderActiveOperation | null;
  quotaExhausted: boolean;
}): AiGenerateDockGate => {
  if (isGuest) return { kind: 'guest' };
  if (activeOperation === 'chat') return { kind: 'chatBusy' };
  if (quotaExhausted) return { kind: 'quotaExhausted' };
  return { kind: 'open' };
};
